import { Trans, useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { useDeleteBankAccount } from '@/query/queries/cash/useDeleteBankAccount';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useIsMobile } from '@scramble/hooks';
import { Button } from '@scramble/ui';
import IconRemove from './featured-icon.svg';
import s from './index.module.scss';

const id = MODAL_IDS.bank_account_remove_modal;

export const BankAccountRemoveModal = ({ account }) => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal account={account} />;
};

export const Modal = ({ account }) => {
  const isMobile = useIsMobile();
  const { closeModal } = useModal();
  const { t } = useTranslation();

  const { mutateAsync: removeBankAccount } = useDeleteBankAccount();

  const onClose = () => {
    closeModal(id);
  };

  const onRemove = async () => {
    const res = await removeBankAccount(account.id);
    res?.success && onClose();
  };

  const content = (
    <div className={s.modal}>
      <div className={s.content}>
        <img src={IconRemove} alt="icon" width={56} height={56} />
        <div className={s.title}>
          {t('bank_accounts:bank_acc_remove_modal.title')}
        </div>
        <div className={s.desc}>
          <Trans
            ns="bank_accounts"
            i18nKey="bank_acc_remove_modal.desc"
            components={{
              Span: <span className="f-500" />,
            }}
            values={{ accNumber: account.account_number }}
          />
        </div>
      </div>
      <div className={s.footer}>
        <Button
          theme="neutral"
          appearance="tonal"
          size="lg"
          label={t('bank_accounts:bank_acc_remove_modal.cancel')}
          onClick={onClose}
        />
        <Button
          theme="danger"
          appearance="filled"
          size="lg"
          label={t('bank_accounts:bank_acc_remove_modal.remove')}
          onClick={onRemove}
        />
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={onClose} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={onClose} showClose>
      {content}
    </ModalCenterLayout>
  );
};
